module.exports = __webpack_public_path__ + "officialStatic/img/productB31.ca9d3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB31.png
// module id = UcYC
// module chunks = 0